import { useCallback } from 'react';
import { useEmojiPickerContext } from '../context/EmojiPickerContext';
const EMOJIS_PER_ROW = 7;
const moveFocusToLeftOrRight = (direction, focusedEmojiElement, emojiGroupWrapperRefs, emojiGroups) => {
    var _a, _b, _c, _d;
    const siblingElementAttribute = direction === 'left' ? 'previousElementSibling' : 'nextElementSibling';
    const childPosition = direction === 'left' ? 'lastChild' : 'firstChild';
    const emojiGroupIndex = direction === 'left' ? emojiGroups.length - 1 : 0;
    if ((_a = focusedEmojiElement === null || focusedEmojiElement === void 0 ? void 0 : focusedEmojiElement.current) === null || _a === void 0 ? void 0 : _a[siblingElementAttribute]) {
        focusedEmojiElement.current[siblingElementAttribute].focus();
    }
    else {
        const parentElement = (_b = focusedEmojiElement === null || focusedEmojiElement === void 0 ? void 0 : focusedEmojiElement.current) === null || _b === void 0 ? void 0 : _b.parentElement;
        if (parentElement === null || parentElement === void 0 ? void 0 : parentElement[siblingElementAttribute]) {
            ((_c = parentElement[siblingElementAttribute]) === null || _c === void 0 ? void 0 : _c[childPosition]).focus();
        }
        else {
            ((_d = emojiGroupWrapperRefs[emojiGroups[emojiGroupIndex]].current) === null || _d === void 0 ? void 0 : _d[childPosition]).focus();
        }
    }
};
const focusLastEmojiRow = (element, index) => {
    const lastRowLength = element.childNodes.length % EMOJIS_PER_ROW || 7;
    const negativeIndex = index >= lastRowLength
        ? EMOJIS_PER_ROW - index + lastRowLength
        : EMOJIS_PER_ROW - index - (EMOJIS_PER_ROW - lastRowLength);
    Array.from(element.childNodes)[element.childNodes.length - negativeIndex].focus();
};
const moveFocusToAboveOrBelow = (direction, focusedEmojiElement, emojiGroupWrapperRefs, emojiGroups) => {
    var _a, _b, _c, _d;
    const parentElement = (_a = focusedEmojiElement === null || focusedEmojiElement === void 0 ? void 0 : focusedEmojiElement.current) === null || _a === void 0 ? void 0 : _a.parentElement;
    const emojiNodes = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.childNodes) || [];
    const index = Array.from(emojiNodes).indexOf(focusedEmojiElement === null || focusedEmojiElement === void 0 ? void 0 : focusedEmojiElement.current);
    const emojiIndex = direction === 'above' ? index - EMOJIS_PER_ROW : index + EMOJIS_PER_ROW;
    const siblingElementAttribute = direction === 'above' ? 'previousElementSibling' : 'nextElementSibling';
    if (emojiNodes[emojiIndex]) {
        emojiNodes[emojiIndex].focus();
    }
    else if (parentElement && parentElement[siblingElementAttribute]) {
        if (direction === 'above') {
            parentElement &&
                focusLastEmojiRow(parentElement[siblingElementAttribute], index);
        }
        else {
            ((_b = parentElement === null || parentElement === void 0 ? void 0 : parentElement.nextElementSibling) === null || _b === void 0 ? void 0 : _b.childNodes[index % EMOJIS_PER_ROW]).focus();
        }
    }
    else if (direction === 'above') {
        focusLastEmojiRow(emojiGroupWrapperRefs[emojiGroups[emojiGroups.length - 1]]
            .current, index);
    }
    else {
        ((_d = (_c = emojiGroupWrapperRefs[emojiGroups[0]]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.childNodes[index % EMOJIS_PER_ROW]).focus();
    }
};
export const useEmojiIconKeyboardNavigation = () => {
    const { emojiData, emojiGroupWrapperRefs, focusedEmoji } = useEmojiPickerContext();
    const emojiGroups = Object.keys(emojiData);
    const handleKeydown = useCallback((e) => {
        const keysAction = {
            ArrowDown: { action: moveFocusToAboveOrBelow, direction: 'under' },
            ArrowLeft: { action: moveFocusToLeftOrRight, direction: 'left' },
            ArrowRight: { action: moveFocusToLeftOrRight, direction: 'right' },
            ArrowUp: { action: moveFocusToAboveOrBelow, direction: 'above' },
        };
        const keyAction = keysAction[e.key];
        if (keyAction) {
            e.preventDefault();
            keyAction.action(keyAction.direction, focusedEmoji, emojiGroupWrapperRefs, emojiGroups);
        }
    }, [focusedEmoji, emojiGroupWrapperRefs, emojiGroups]);
    return {
        handleKeydown,
    };
};
//# sourceMappingURL=useEmojiIconKeyboardNavigation.js.map